import { render, staticRenderFns } from "./LayoutOverlay.vue?vue&type=template&id=f5ba0afe&scoped=true&"
import script from "./LayoutOverlay.vue?vue&type=script&lang=js&"
export * from "./LayoutOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LayoutOverlay.vue?vue&type=style&index=0&id=f5ba0afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba0afe",
  null
  
)

export default component.exports